module.exports = __webpack_public_path__ + "media/images/property_photo6-94bdbe0b.jpg";